import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import Axios from 'axios'

Vue.prototype.$http = Axios;

var httpPath = "";
if(document.location.host === "localhost:8080"){
    httpPath = "/vue";
}

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(VueRouter);

const store = new Vuex.Store({
    state: {
        httpPath: '',
        httpPathCurrentPage: "",
        viewMode: "",
        windowWidth: 0,
        windowHeight: 0,
        contentWidth: 0,
        contentHeight: 0,
        contentLeft: 0,
        contentTop: 0
    },
    mutations: {
        httpPathSet (state, httpPath) {
            state.httpPath = httpPath;
        },
        httpPathCurrentPage(state, httpPathCurrentPage){
            state.httpPathCurrentPage = httpPathCurrentPage;
        },
        viewMode(state, viewMode){
            state.viewMode = viewMode;
        },
        windowWidth(state, windowWidth){
            state.windowWidth = windowWidth;
        },
        windowHeight(state, windowHeight){
            state.windowHeight = windowHeight;
        },
        contentWidth(state, contentWidth){
            state.contentWidth = contentWidth;
        },
        contentHeight(state, contentHeight){
            state.contentHeight = contentHeight;
        },
        contentLeft(state, contentLeft){
            state.contentLeft = contentLeft;
        },
        contentTop(state, contentTop){
            state.contentTop = contentTop;
        }
    },
    actions: {
        httpPathCurrentPage({commit}, httpPathCurrentPage){
            return new Promise((resolve) => {
                commit('httpPathCurrentPage', httpPathCurrentPage);
                resolve();
            });
        },
        setViewMode({commit}, viewMode){
            return new Promise((resolve) => {
                commit('viewMode', viewMode);
                resolve();
            });
        },
        setWindowWidth({commit}, windowWidth){
            return new Promise((resolve) => {
                commit('windowWidth', windowWidth);
                resolve();
            });
        },
        setWindowHeight({commit}, windowHeight){
            return new Promise((resolve) => {
                commit('windowHeight', windowHeight);
                resolve();
            });
        },
        setContentWidth({commit}, contentWidth){
            return new Promise((resolve) => {
                commit('contentWidth', contentWidth);
                resolve();
            });
        },
        setContentHeight({commit}, contentHeight){
            return new Promise((resolve) => {
                commit('contentHeight', contentHeight);
                resolve();
            });
        },
        setContentLeft({commit}, contentLeft){
            return new Promise((resolve) => {
                commit('contentLeft', contentLeft);
                resolve();
            });
        },
        setContentTop({commit}, contentTop){
            return new Promise((resolve) => {
                commit('contentTop', contentTop);
                resolve();
            });
        }
    },
    getters: {
        httpPath: state => state.httpPath,
        httpPathCurrentPage: state => state.httpPathCurrentPage,
        viewMode: state => state.viewMode,
        windowWidth: state => state.windowWidth,
        windowHeight: state => state.windowHeight,
        contentWidth: state => state.contentWidth,
        contentHeight: state => state.contentHeight,
        contentLeft: state => state.contentLeft,
        contentTop: state => state.contentTop
    }
});

store.commit('httpPathSet', httpPath);

import PageHome from './components/PageHome'
import PageITS from './components/PageITS'
import PageServices1C from './components/PageServices1C'
import PageTarifi from './components/PageTarifi'
import PageProdazha from './components/PageProdazha'
import PageContacts from './components/PageContacts'
import Page1CFresh from './components/Page1CFresh'
import PageAds from './components/PageAds'
import PageDataMatrixMain from './components/DataMatrix/PageDataMatrixMain'
import PageDataMatrixSupport from './components/DataMatrix/PageDataMatrixSupport'
import PageDataMatrixSale from './components/DataMatrix/PageDataMatrixSale'
import Page404 from './components/Page404'

const routes = [
    { path: httpPath + '/', component: PageHome },
    { path: httpPath + '/итс', component: PageITS },
    { path: httpPath + '/сервисы', component: PageServices1C },
    { path: httpPath + '/тарифы', component: PageTarifi },
    { path: httpPath + '/продукция-1с', component: PageProdazha },
    { path: httpPath + '/кассовое-оборудование', component: PageProdazha },
    { path: httpPath + '/торговое-оборудование', component: PageProdazha },
    { path: httpPath + '/антивирусное-по', component: PageProdazha },
    { path: httpPath + '/электронные-подписи', component: PageProdazha },
    { path: httpPath + '/офд', component: PageProdazha },
    { path: httpPath + '/контакты', component: PageContacts },
    { path: httpPath + '/1с-фреш', component: Page1CFresh },
    { path: httpPath + '/реклама', component: PageAds },
    { path: httpPath + '/по-datamatrix', component: PageDataMatrixMain },
    { path: httpPath + '/по-datamatrix-поддержка', component: PageDataMatrixSupport },
    { path: httpPath + '/по-datamatrix-продажа', component: PageDataMatrixSale },
    { path: httpPath + '/*', component: Page404 }
];

const router = new VueRouter({
  routes // сокращённая запись для `routes: routes`
  , mode: 'history'
});

router.beforeEach((to, from, next) => {
    store.dispatch('httpPathCurrentPage', to.path);
    next();
});

function resize() {
    //store.dispatch('setWindowWidth', window.innerWidth);
    //store.dispatch('setWindowWidth', window.clientWidth);
    store.dispatch('setWindowWidth', document.documentElement.clientWidth);
    store.dispatch('setWindowHeight', window.innerHeight);
}

window.onresize = resize;

resize();

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');






